import { createFileRoute, redirect } from '@tanstack/react-router';
import { ensurePermissions } from '@/hooks/usePermissions';
import { hasFeature } from '@/lib/utils/features';
import { bootstrapSession } from '@/lib/utils/session';
import { useSessionStore } from '@/store/sessionStore';

export const Route = createFileRoute('/(client)/supply-chain-mapping')({
  beforeLoad: async ({ location }) => {
    const user = useSessionStore.getState().user ?? (await bootstrapSession());
    if (!hasFeature(user, 'supply-chain-mapping')) {
      throw redirect({ to: '/dashboard' });
    }

    const perms = await ensurePermissions();
    if (!perms['supply-chain-mapping'].canRead) {
      throw redirect({ to: '/dashboard' });
    }

    if (
      location.pathname === '/supply-chain-mapping' ||
      location.pathname === '/supply-chain-mapping/'
    ) {
      throw redirect({ to: '/supply-chain-mapping/supply-chains/active' });
    }
  },
});
